// extracted by extract-css-chunks-webpack-plugin
module.exports = {"commentBox":"commentBox-2lCDAeGF"};